import React from 'react';
import { Row, Col } from 'react-bootstrap5';

export default function Index() {
  return (
    <div className="content">
      <Row>
        <Col lg={{ span: 6, order: 'last' }}>
          <div className="bg-photo bg-managers-programs-no-policy-photo" />
        </Col>

        <Col lg={{ span: 6, order: 'first' }}>
          <div className="py-4 px-sm-4 p-xxl-5">
            <h1 className="mb-5">Programs</h1>

            <p>Create a policy to get started!</p>

            <p>
              Customize your programs to match the specific needs of your team,
              to ensure full alignment with personal and company priorities.
              This kind of proactive approach to employee performance and
              retention gives businesses a competitive edge.
            </p>

            <p>Create your policy and get started today!</p>

            <a href="#todo" className="btn btn-outline-primary mt-4 me-2">Create Policy</a>
            <a href="#todo" className="btn btn-primary mt-4 ">Build Program</a>
          </div>
        </Col>
      </Row>
    </div>
  );
}
